import axios from 'axios'
import {API_URL} from "../../helpers/crud-helper/consts";

const BLOG_URL = `${API_URL}/blog`

const getBlogs = (data: any, currentLanguageCode: any, tag?: string): Promise<any> => {
    let url = `${BLOG_URL}?page=${data}&language=${currentLanguageCode}&with_pagination_data=${true}`;

    if (tag && tag !== '') {
        url += `&tag=${tag}`
    }

    return axios
        .get(url)
        .then((response) => response)
}

const showBlog = (slug: any, currentLanguageCode: any): Promise<any> => {
    return axios
        .get(`${BLOG_URL}/${slug}?language=${currentLanguageCode}`)
        .then((response) => response)
}

export {getBlogs, showBlog}